<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Create Order",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Create Order",
            items: [
               {
                  text: "Orders",
                  href: "/orders",
               },
               {
                  text: "Create Order",
                  active: true,
               },        
            ],

            order: {
               patient_id: null,
               mobile: '',
               delivery_type: '1',
               notes: '',
               delivery_address: 'Edappalli, Kochi',
               delivery_date: '',
               location: '',
               latitude: null,
               longitude: null,
            },

            patients: [
               {id: 1, patient_name: 'Patient 1 | Mob No: 9110011001'},
               {id: 2, patient_name: 'Patient 2 | Mob No: 9110011001'},
               {id: 3, patient_name: 'Patient 3 | Mob No: 9110011001'},
               {id: 4, patient_name: 'Patient 4 | Mob No: 9110011001'},
               {id: 5, patient_name: 'Patient 5 | Mob No: 9110011001'},
               {id: 6, patient_name: 'Patient 6 | Mob No: 9110011001'},
               {id: 7, patient_name: 'Patient 7 | Mob No: 9110011001'},
            ],
            patient_visible: false,
            patient_keyword: '',
            patient_id: 0,

            delivery_location: '',
            delivery_marker: { position: { lat: null, lng: null } },
            delivery_center: { lat: null, lng: null },
            delivery_current_place: null,

            delivery_mapOptions: {
               disableDefaultUI: true,
            },


         };
      },
      mounted() {
    
      },

      created() {
         this.setRegularDeliveryDate();
      },

      methods: {

         setRegularDeliveryDate() {
            var date = new Date();
            date.setDate(date.getDate() + 2);
            this.order.delivery_date = date.toISOString().split('T')[0];
         },

         closePatientSearch() {
            this.patient_visible = false;
            this.patient_keyword = '';
            this.patient_id = 0;
         },

         setPatient() {
            this.patient_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.patient_visible = false;
            this.order.mobile = '9110011001';
         },

         fetchPatients() { 
            this.patient_visible = true;  
         },

         //sets the position of marker when dragged
         deliveryHandleMarkerDrag(e) {
            this.delivery_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         deliveryPanToMarker() {
            this.$refs.deliveryMapRef.panTo(this.delivery_marker.position);
            this.$refs.deliveryMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         deliveryHandleMapClick(e) {
            this.delivery_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         deliverySetPlace(place) {
            this.delivery_current_place = place;
            if(this.delivery_current_place) {
               const marker = {
                  lat: this.delivery_current_place.geometry.location.lat(),
                  lng: this.delivery_current_place.geometry.location.lng(),
               };
               this.delivery_center = marker;
               this.delivery_marker.position = marker;
               this.delivery_location = place.formatted_address;
            }
         },

         
      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacy.orders' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  
                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light"> -->
                     <form class="form-horizontal" role="form">
                        <div class="row">
                           <div class="form-group col-md-6">
                              <label>Patient <span class="text-danger">*</span></label>
                              <div class="search-select">
                                 <span class="search-close" v-if="patient_visible" @click="closePatientSearch"><i class="dripicons dripicons-cross"></i></span>
                                       
                                 <b-form-input v-model="patient_keyword"  @keyup="fetchPatients()"  autocomplete="off" placeholder="Search here..."></b-form-input>
                                 
                                 <b-form-select v-if="patient_visible && Boolean(patients.length)" v-model="patient_id" :select-size="patients.length < 10 ? (patients.length <= 1 ? 2 : patients.length) : 10" @change="setPatient">
                                    <b-form-select-option v-for="patient in patients" :key="patient.id" :value="patient.id">{{ patient.patient_name }} </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select v-if="patient_visible && !Boolean(patients.length)" v-model="patient_id" :select-size="2">                  
                                       <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                 </b-form-select>
                              </div>
                           </div>   

                           <div class="form-group col-md-6">
                              <label>Mobile</label>
                              <input type="text" class="form-control" v-model="order.mobile"/>
                           </div>

                        </div>

                        <div class="row">
                           <div class="form-group col-md-6">
                              <label>Prescription <span class="text-danger">*</span></label>
                              <input type="file" class="form-control">
                           </div>   
                           <div class="form-group col-md-6">
                              <label>Amount (in Rs)<span class="text-danger">*</span></label>
                              <input type="text" class="form-control">     
                           </div>                        
                        </div>

                        <div class="row">
                           <div class="form-group col-md-12">
                              <label>Details of medicines</label>
                              <textarea class="form-control" rows="5"></textarea>
                           </div>

                           <div class="form-group col-md-7 col-lg-6">
                              <label>Delivery Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="order.delivery_type" name="delivery_type"> 
                                 <div class="form-check-inline"> 
                                    <b-form-radio value="1" class="mr-5">
                                       Regular Delivery
                                    </b-form-radio> 
                                    <p class="small">Rs. 10 Delivery charge<br>Delivery in 1 to 2 days</p>
                                 </div>
                                 <div class="form-check-inline">  
                                    <b-form-radio value="2">
                                       Express Delivery
                                    </b-form-radio>
                                    <p class="small">Rs. 20 Delivery charge<br>Same day delivery</p>
                                 </div>
                              </b-form-radio-group>
                           </div>

                           <div class="form-group col-md-5 col-lg-6">
                              <label>Delivery Date & Time <span class="text-danger">*</span></label>
                              <b-form-input type="datetime-local" v-model="order.delivery_date"></b-form-input>
                           </div>
                        </div>

                        <div class="row">
                           <div class="form-group col-md-6">
                              <label>Delivery Address <span class="text-danger">*</span> </label>
                              <textarea class="form-control" rows="3"></textarea>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Remarks </label>
                              <textarea class="form-control" rows="3"></textarea>
                           </div>

                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="deliverySetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="delivery_location"/>
                              
                              <GmapMap v-if="delivery_location"
                                 :center="delivery_center"
                                 :zoom="18"
                                 map-style-id="delivery-roadmap"
                                 :options="delivery_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="deliveryMapRef"
                                 @click="deliveryHandleMapClick">
                                    <GmapMarker
                                       :position="delivery_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="deliveryHandleMarkerDrag"
                                       @click="deliveryPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="delivery_marker.position.lat" autocomplete="off"></b-form-input>
                              
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="delivery_marker.position.lng" autocomplete="off"></b-form-input>
                              
                           </b-col>

                           <div class="form-group col-md-12">
                              <label class="control-label">Private Delivery</label>
                              <b-form-checkbox                                
                                 v-model="private_delivery"
                                 value="1"
                                 unchecked-value="0"
                              >
                              <p class="small ms-2">Items will not be displayed on the package</p>
                           </b-form-checkbox>
                           </div>
                        </div>


                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'orders' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  <!-- </b-card> -->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
